import { TextBox as TextBoxType } from "store/features/memeGenerator/types";

interface TextBoxProps {
    textBox: TextBoxType;
    xRatio: number;
    yRatio: number;
}

export const TextBox = ({ textBox, xRatio, yRatio }: TextBoxProps) => {
    return (
        <>
            <div
                className={`mg-textBox-border absolute touch-none left-0 top-0 cursor-move z-10`}
                style={{
                    width: textBox.width,
                    height: textBox.height,
                    transform: `translate(${textBox.left}px,${textBox.top}px) rotate(${textBox.rotation}deg) scale(${xRatio}, ${yRatio})`,
                    borderColor: textBox.showBorder ? undefined : "transparent",
                    background: "none",
                    zIndex: 10 + textBox.zIndex,
                }}
            >
                <div className={`w-full h-full relative`}>
                    <div
                        className={`w-full h-full flex ${
                            textBox.alignment.horizontal === "start"
                                ? "text-left justify-start"
                                : textBox.alignment.horizontal === "middle"
                                ? "text-center justify-center"
                                : "text-right justify-end"
                        } ${
                            textBox.alignment.vertical === "start"
                                ? "items-start"
                                : textBox.alignment.vertical === "middle"
                                ? "items-center"
                                : "items-end"
                        } z-10`}
                    >
                        <div
                            className={`${textBox.forceCaps && "uppercase"} outline-none w-full select-none ${
                                textBox.decoration.underline ? "underline" : ""
                            } ${textBox.decoration.italic ? "italic" : ""} ${
                                textBox.decoration.bold ? "font-semibold" : ""
                            }`}
                            defaultValue={textBox.value}
                            spellCheck={false}
                            style={{
                                fontSize: `${textBox.fontSize}px`,
                                fontFamily: textBox.fontFamily,
                                color: textBox.fontColor,
                                letterSpacing: `${textBox.spacing.letter}px`,
                                WebkitTextStroke: "0px",
                                lineHeight: textBox.spacing.line,
                                textShadow: textBox.shadow?.isActive
                                    ? `${Array.from(Array(10).keys())
                                          .map(() => `0px 0px ${textBox.shadow?.blurRadius}px ${textBox.shadow?.color}`)
                                          .join(",")}`
                                    : undefined,
                                opacity: textBox.opacity / 100,
                            }}
                            dangerouslySetInnerHTML={{ __html: textBox.innerHTML }}
                        ></div>
                    </div>
                </div>
            </div>
            {/**
             * underlay
             */}
            <div
                className="mg-textBox-border absolute touch-none left-0 top-0 z-0"
                style={{
                    width: textBox.width,
                    height: textBox.height,
                    transform: `translate(${textBox.left}px,${textBox.top}px) rotate(${textBox.rotation}deg)`,
                    borderColor: "transparent",
                    background: "none",
                }}
            >
                <div className={`w-full h-full relative`}>
                    <div
                        className={`w-full h-full flex ${
                            textBox.alignment.horizontal === "start"
                                ? "text-left justify-start"
                                : textBox.alignment.horizontal === "middle"
                                ? "text-center justify-center"
                                : "text-right justify-end"
                        } ${
                            textBox.alignment.vertical === "start"
                                ? "items-start"
                                : textBox.alignment.vertical === "middle"
                                ? "items-center"
                                : "items-end"
                        } z-10`}
                    >
                        <div
                            className={`${textBox.forceCaps && "uppercase"} outline-none w-full select-none ${
                                textBox.decoration.italic ? "italic" : ""
                            } ${textBox.decoration.bold ? "font-semibold" : ""}`}
                            contentEditable={true}
                            defaultValue={textBox.value}
                            dangerouslySetInnerHTML={{ __html: textBox.innerHTML }}
                            style={{
                                fontSize: `${textBox.fontSize}px`,
                                fontFamily: textBox.fontFamily,
                                color: textBox.fontColor,
                                letterSpacing: `${textBox.spacing.letter}px`,
                                WebkitTextStroke: textBox.outline?.isActive
                                    ? `${textBox.outline.size}px ${textBox.outline.color}`
                                    : undefined,
                                lineHeight: textBox.spacing.line,
                                opacity: textBox.opacity / 100,
                            }}
                        ></div>
                    </div>
                </div>
            </div>
        </>
    );
};
